import Box from "@mui/material/Box"
import Typography from "@mui/material/Typography"
import PropTypes from "prop-types"

import Column from "../../../common/components/Column"
import { describeHistoryEntry } from "./meetingUtils"

// Oldest first: booked, then each reschedule, then the cancellation, so the
// meeting's story reads top to bottom.
export default function MeetingHistory({ history }) {
  if (!history || history.length === 0) return null
  return (
    <Column gap={1}>
      <Typography variant="caption" color="text.secondary">
        History
      </Typography>
      <Box
        component="ol"
        aria-label="Meeting history"
        sx={{ listStyle: "none", m: 0, p: 0 }}
      >
        {history.map((entry, index) => {
          const step = describeHistoryEntry(entry)
          const isLast = index === history.length - 1
          return (
            <Box
              component="li"
              key={entry.id ?? `${entry.action}-${index}`}
              sx={{ display: "flex", gap: 1.5 }}
            >
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                <Box
                  aria-hidden="true"
                  sx={{
                    width: 10,
                    height: 10,
                    mt: 0.75,
                    borderRadius: "50%",
                    backgroundColor: step.color,
                    flexShrink: 0,
                  }}
                />
                {isLast ? null : (
                  <Box
                    aria-hidden="true"
                    sx={{ width: 2, flex: 1, backgroundColor: "divider" }}
                  />
                )}
              </Box>
              <Box sx={{ pb: isLast ? 0 : 1.5, minWidth: 0 }}>
                <Typography variant="body2" sx={{ fontWeight: 600 }}>
                  {step.title}
                </Typography>
                <Typography variant="caption" color="text.secondary">
                  {step.at}
                </Typography>
                {step.detail ? (
                  <Typography variant="body2">{step.detail}</Typography>
                ) : null}
                {step.reason ? (
                  <Typography
                    variant="body2"
                    color="text.secondary"
                    sx={{ whiteSpace: "pre-wrap", wordBreak: "break-word" }}
                  >
                    Reason: {step.reason}
                  </Typography>
                ) : null}
              </Box>
            </Box>
          )
        })}
      </Box>
    </Column>
  )
}

MeetingHistory.propTypes = {
  history: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      action: PropTypes.string.isRequired,
      at: PropTypes.string,
      performed_by_name: PropTypes.string,
    })
  ),
}
